import ServiceWrapper, { type ServiceOptions } from "@utils/ServiceWrapper";
import {
    OE_ALL_ACTION_CONTROLS,
    OE_DISTRICT_WINDOWS_BY_SCHOOLYEAR,
    OE_PARTICIPATING_SCHOOL,
    OE_SCHOOL_YEAR_KEY,
    OE_STUDENT,
    OE_STUDENT_DETAILS,
    OE_STUDENT_SEARCH
} from "@const/OpenEnrollmentConst";

interface OpenEnrollmentDaoOptions {
    action: string;
    key?: number | string | null;
    params?: unknown;
    schoolYearKey?: number | null | string;
    signal?: AbortSignal;
}

/**
 * Data Access Object for the Open Enrollment API.
 */
const OpenEnrollmentDao = <T = unknown>(options: OpenEnrollmentDaoOptions): Promise<{ data: T }> | null => {
    const { action, key, params, schoolYearKey, signal } = options;

    const requestOptions: ServiceOptions = { url: "", method: "GET" };

    const actionConfig: Record<string, Partial<ServiceOptions>> = {
        allActionControlsRead: { method: "GET", url: OE_ALL_ACTION_CONTROLS, params },
        allDistrictWindowsRead: {
            method: "GET",
            url: `${OE_DISTRICT_WINDOWS_BY_SCHOOLYEAR}/${schoolYearKey}/index.json`
        },
        participatingSchoolRead: {
            method: "GET",
            url: `${OE_PARTICIPATING_SCHOOL}/${key}/detail.json`,
            params: params ?? undefined
        },
        schoolYearRead: { method: "GET", url: OE_SCHOOL_YEAR_KEY },
        studentDetailsRead: { method: "GET", url: `${OE_STUDENT_DETAILS}/${key}/detail.json` },
        studentDetailsSearch: { method: "GET", url: `${OE_STUDENT_SEARCH}/${schoolYearKey}/index.json`, params },
        studentsByParentGuidRead: { method: "GET", url: `${OE_STUDENT}/${schoolYearKey}/index.json`, params }
    };

    const config = actionConfig[action];
    if (!config) {
        const error = new Error(`OpenEnrollmentDao: Invalid action "${action}" provided`);
        console.error("OpenEnrollmentDao: Invalid action provided");
        throw error;
    }

    return ServiceWrapper.serviceCall({
        options: { ...requestOptions, ...config, signal }
    }) as Promise<{ data: T }>;
};

export default OpenEnrollmentDao;
